"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.join");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.string.trim");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _typeValidation = _interopRequireDefault(require("./typeValidation"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// #####################################################################################################
// NOTE: Do NOT remove 'sortKeys' as a prop even though it is reported by linting as not being used.
//       it is used with the PctyBindable grid for sorting.
// #####################################################################################################
// eslint-disable-next-line no-unused-vars
var PctyFieldSorter = function PctyFieldSorter(_ref) {
  var children = _ref.children,
      sortDirection = _ref.sortDirection,
      onClick = _ref.onClick,
      sortKeys = _ref.sortKeys,
      automationId = _ref.automationId,
      __disabled = _ref.__disabled,
      __TYPE = _ref.__TYPE,
      other = (0, _objectWithoutProperties2.default)(_ref, ["children", "sortDirection", "onClick", "sortKeys", "automationId", "__disabled", "__TYPE"]);

  var getAutomation = function getAutomation(suffix) {
    return !automationId ? {} : {
      'data-automation-id': automationId + (suffix ? "-".concat(suffix) : '')
    };
  };

  var getOnClick = function getOnClick() {
    return __disabled ? {} : {
      onClick: onClick
    };
  };

  var _props = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, other), getAutomation()), getOnClick()), {}, {
    className: [other.className || '', 'pcty-grid-column-sortable', getSortDirectionClassName(sortDirection.toLowerCase())].join(' ').trim()
  });

  return /*#__PURE__*/_react.default.createElement("span", _props, children);
};

var getSortDirectionClassName = function getSortDirectionClassName(sortDirection) {
  switch (sortDirection) {
    case 'asc':
      return 'pcty-grid-column-ascending';

    case 'desc':
      return 'pcty-grid-column-descending';

    default:
      return '';
  }
};

PctyFieldSorter.propTypes = {
  children: _propTypes.default.node.isRequired,

  /** For PctyBindableGrid, an array of property names to sort the data by. */
  sortKeys: _propTypes.default.array,

  /** Specifies the sort direction */
  sortDirection: _propTypes.default.oneOf(['desc', 'asc', '']),

  /** Handles the onClick event */
  onClick: _propTypes.default.func,

  /** A string that can be referenced by UI automation tools */
  automationId: _propTypes.default.string,
  __disabled: _propTypes.default.bool,
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation.default)(props, propName, componentName, 'PctyFieldSorter');
  }
  /** INCLUDE OTHER */

};
PctyFieldSorter.defaultProps = {
  sortDirection: '',
  onClick: function onClick() {},
  __disabled: false,
  __TYPE: 'PctyFieldSorter'
};
var _default = PctyFieldSorter;
exports.default = _default;